import { API_CREDENTIALS, API_ENDPOINTS } from "./apiEndpoints";
import axiosClient from "./axiosClient";
import Cookies from "js-cookie"; // Import js-cookie

export const fetchTours = ({ date }) => {
  const token = Cookies.get("token"); // Get the token from cookies

  return axiosClient.post(
    API_ENDPOINTS.GET_TOURS,
    {
      date: date && date,
      hide_booked: 1,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        "user-token": token, // Use token from cookies
        Accept: "application/json",
        "Accept-Language": "en",
        "platform-key": "1234567",
        platform: "web",
      },
    }
  );
};

export const fetchToursDates = ({ all }) => {
  const token = Cookies.get("token"); // Get the token from cookies

  return axiosClient.post(
    API_ENDPOINTS.GET_TOURS,
    {
      all: all,
    },
    {
      headers: {
        "secure-business-key": API_CREDENTIALS.SECURE_BUSINESS_KEY,
        Accept: "application/json",
        "user-token": token, // Use token from cookies
        "Accept-Language": "en",
        "platform-key": "1234567",
        platform: "web",
      },
    }
  );
};
